import VisualizarVendaFormaPagamento from './VisualizarVendaFormaPagamento';

export default VisualizarVendaFormaPagamento;
